export function getCssVariable(variableName) {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName);
}

export function pxToNumber(value) {
  return Number(value.replace('px', ''));
}
